// E-Fatura Ürünlerini Aktar penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.eInvoiceImport';

export const eInvoiceImportGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'E-fatura kalemleri nasıl aktarılır?'),
  intro: t(`${G}.intro`, 'Gelen e-faturadaki ürünleri stok kartlarınızla eşleştirip alış faturası formuna eklersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kalem listesi'),
    footer: t(`${G}.regions.footer`, 'İçe Aktar'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Pencere açılınca e-fatura kendiliğinden okunur ve kalemleri listelenir. Sistem her kalemi stoktaki bir ürünle otomatik eşleştirmeye çalışır; siz kontrol edip düzeltirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bu pencere stoğu değiştirmez; yalnız kalemleri alış faturası formuna ekler. Stok girişi, alış faturasını kaydettiğinizde yapılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Aktarılacak kalemleri seçin'),
      text: t(`${G}.s2.text`, 'Başlangıçta tüm kalemler seçilidir. Satıra veya kutucuğa tıklayarak seçimi kaldırabilir, başlıktaki kutucukla hepsini seçip bırakabilirsiniz. Altta kaç kalemin seçildiği yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Birim fiyat KDV hariçtir; Toplam sütunu indirim ve KDV dahil satır tutarıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Eşleşmeyi kontrol edin'),
      text: t(`${G}.s3.text`, 'Eşleşme sütunundaki etiket durumu gösterir: "Eşleşti: … (%)" otomatik eşleşme (%80 ve üstü yeşil, altı turuncu), "Manuel: …" sizin seçtiğiniz ürün, "Yeni Ürün" eşleşme bulunamadı, "Stoksuz Ürün" stok kartına bağlanmayan kalem.'),
      tips: [
        t(`${G}.s3.tip1`, '"Yeni Ürün" olarak kalan kalem faturaya stok kartı olmadan, elle girilmiş kalem olarak eklenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Eşleşmeyi değiştirin'),
      text: t(`${G}.s4.text`, 'Kalem simgesine (Eşleştirmeyi Değiştir) basın ve "Stok Ürünü Ara" kutusuna en az 2 harf yazıp ürünü seçin. Altındaki düğmelerle başka seçenekler de var.'),
      tips: [
        t(`${G}.s4.tip1`, 'Yeni Ürün Ekle: e-faturadaki adla dolu bir ürün kartı açar; kaydedince kalem o ürünle eşleşir.'),
        t(`${G}.s4.tip2`, 'Eşleştirme İptal: sizin seçiminizi kaldırıp otomatik eşleşmeye döner.'),
        t(`${G}.s4.tip3`, 'Stoksuz Ürün Yap: kalemi stok kartına bağlamadan ekler (hizmet, masraf gibi).'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Depoyu seçin'),
      text: t(`${G}.s5.text`, 'Depo sütununda her kalem için ürünün gireceği depo seçilir. Başlangıçta varsayılan depo (yoksa ilk depo) seçilidir; kalem bazında değiştirebilirsiniz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. İçe aktarın'),
      text: t(`${G}.s6.text`, '"… Ürünü İçe Aktar" düğmesi seçili kalemleri alış faturası formundaki mevcut kalemlerin sonuna ekler ve pencereyi kapatır. Ardından faturayı kontrol edip kaydedin. Başlıktaki (i) bu rehberi yeniden açar.'),
      tips: [
        t(`${G}.s6.tip1`, 'Hiç kalem seçili değilse düğme kapalıdır.'),
        t(`${G}.s6.tip2`, 'Okuma hatası olursa pencerede nedeni yazar; "Kapat" ile çıkabilirsiniz.'),
      ],
    },
  ],
});
